import type React from 'react'

/**
 * Station-page-template SVG glyphs the shared `@mammoth/design-kit`
 * registry does not (yet) ship. Each is the verbatim Figma export
 * (header node 8597:44779), re-stroked with `currentColor` so it binds
 * to the surrounding text-colour — same pattern as
 * `packages/station-details/src/icons/SdGlyphs.tsx`.
 *
 * TODO(@mammoth/design-kit): lift into the shared icon registry when a
 * second consumer appears.
 */

interface GlyphProps {
  /** Square edge length in px. */
  size: number
  className?: string
}

/** Magnifier for the header search button (Figma 8597:44801). */
export function SearchGlyph({ size, className }: GlyphProps): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26.0006 26.0006"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M11.0529 18.5251C15.1813 18.5251 18.528 15.1784 18.528 11.0499C18.528 6.92152 15.1813 3.57477 11.0529 3.57477C6.92445 3.57477 3.5777 6.92152 3.5777 11.0499C3.5777 15.1784 6.92445 18.5251 11.0529 18.5251Z"
        stroke="currentColor"
        strokeWidth="2.27505"
      />
      <path
        d="M17.551 17.55L22.7511 22.7501"
        stroke="currentColor"
        strokeWidth="2.27505"
        strokeLinecap="round"
      />
    </svg>
  )
}

/** Line roundel ring, tinted via currentColor — the heading/line-row
 * mark (Figma Icons/SubwayLines, path from the 8597:41920 export). */
export function LineRoundelGlyph({ size, className }: GlyphProps): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56.4849 56.4849"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.2387 51.6155C41.1858 51.6155 51.6155 41.218 51.6155 28.2656C51.6155 15.3133 41.1858 4.86938 28.2387 4.86938C15.2972 4.86938 4.86938 15.3133 4.86938 28.2656C4.86938 41.218 15.2972 51.6155 28.2387 51.6155V51.6155Z"
        stroke="currentColor"
        strokeWidth="9.73877"
      />
    </svg>
  )
}

/** Right-pointing chevron — breadcrumb separators (Figma 8597:44812)
 * and the line-row affordance (8597:41552); tinted via currentColor. */
export function ChevronRightGlyph({ size, className }: GlyphProps): React.JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15.2583 15.2583"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M5.08736 3.17798L9.53769 7.62831L5.08736 12.0786"
        stroke="currentColor"
        strokeWidth="1.5894"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
